import React from 'react';

const NotFound404 = () => {
    return (
        <div>
            <h1> Page Not Found (404)</h1>
        </div>
    )
}

export default NotFound404